<template>
    <div class="mainCon">
      <div class="contbanner standbymain">
        <div class="mainDivWidth flexDiv stanmain">
          <div class="stanLeft wow fadeInLeft animated">
            <div class="scene-Header">
              <div class="flexDiv">
                <div class="stancont">
                  <p class="sceneTitle">后台发券活动</p> 
                  <p class="backtxt">批量发放快速高效</p>
                </div>
                <p class="explantxt">佰付美系统后台为指定用户立即或定时发券</p>
                <div class="startban">
                    <p>推荐指数：</p>
                    <img src="static/img/activity/start.png" alt="">
                    <img src="static/img/activity/start.png" alt="">
                    <img src="static/img/activity/start.png" alt="">
                  </div>
              </div>
            </div>
          </div>
          <div class="stanRight wow fadeInRight animated">
            <img src="static/img/activity/buyCoupon/bannerpic.png" alt="">
          </div>
        </div>
      </div>
      <div class="conticon">
        <div class="mainDivWidth flexDiv conmains" >
          <div class="ditchList wow zoomIn animated" v-for="conlis in conticonList" @click="changeanchorId(conlis.id)">
            <img :src="conlis.pic" alt="">
            <p>{{conlis.title}}</p>
          </div>
        </div>
      </div>
      <section id="recommend">
        <div class="mainDivWidth" >
          <h3 class="sectionTitle">推荐理由</h3>
          <div class="recommend flexDiv">
            <div v-for="rec in recomList"  class="recomlist">
              <img :src="rec.icons" alt="">
              <div class="recomtxt">
                <p>{{rec.title}}</p>
                <span>{{rec.cont}}</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="contbg" id="contbg">
        <div class="mainDivWidth">
          <h3 class="sectionTitle whiteText">活动数据</h3>
          <div class="flexDiv actDatamain">
            <div class="activedata" v-for="actl in activedatas">
              <p>{{actl.nums}}</p>
              <span>{{actl.explain}}</span>
            </div>
          </div>
        </div>
      </section>
      <section id="flowPath">
        <div class="mainDivWidth">
          <h3 class="sectionTitle">活动流程</h3>
          <div class="flexDiv flowpics">
              <img src="static/img/activity/actAdminSend/casepic/case01.png" alt="">
              <img class="direct" src="static/img/activity/dirsmall.png" alt="">
              <img src="static/img/activity/actAdminSend/casepic/case02.png" alt="">
              <img class="direct" src="static/img/activity/dirsmall.png" alt="">
              <img src="static/img/activity/actAdminSend/casepic/case03.png" alt="">
              <img class="delay-3s direct" src="static/img/activity/dirsmall.png" alt="">
              <img src="static/img/activity/actAdminSend/casepic/case04.png" alt="">
              <img class="direct" src="static/img/activity/dirsmall.png" alt="">
              <img src="static/img/activity/actAdminSend/casepic/case05.png" alt="">
              <img class="direct" src="static/img/activity/dirsmall.png" alt="">
              <img src="static/img/activity/actAdminSend/casepic/case06.png" alt="">
            </div>
        </div>
      </section>
      <section id="actCase">
        <div class="casebg">
          <div class="mainDivWidth">
            <h3 class="sectionTitle whiteText">活动案例</h3>
            <div class="flexDiv casecont">
              <img class="wow rotateInDownRight animated" src="static/img/activity/actAdminSend/flow/flow01.png" alt="">
              <img class="wow rotateInDownRight animated" src="static/img/activity/actAdminSend/flow/flow02.png" alt="">
              <img class="wow rotateInDownRight animated" src="static/img/activity/actAdminSend/flow/flow03.png" alt="">
            </div>
          </div>
        </div>
      </section>
      
      <section>
        <div class="mainDivWidth">
          <h3 class="sectionTitle">我们还可以做到</h3>
          <div class="flexDiv maskcont">
            <div class="maskban wow bounceIn animated" v-for="mas in maskList">
              <img :src="mas.pics" alt="">
              <p>{{mas.title}}</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  </template>
  
  <script>
  import { WOW } from "wowjs";
  export default {
    name: 'actAdminSend',
    data:function(){
      return {
        conticonList:[
          {
            id:"recommend",
            title:"推荐理由",
            pic:"static/img/activity/standby/icon-2/logo01.png"
          },
          {
            id:"contbg",
            title:"活动数据",
            pic:"static/img/activity/standby/icon-2/logo02.png"
          },
          {
            id:"flowPath",
            title:"活动流程",
            pic:"static/img/activity/standby/icon-2/logo03.png"
          },
          {
            id:"actCase",
            title:"活动案例",
            pic:"static/img/activity/standby/icon-2/logo04.png"
          },
        ],
        recomList: [
          {
            icons:"static/img/activity/actAdminSend/icon-1/case01.png",
            title:"批量发放快速高效",
            cont:"后台根据白名单批量发放优惠券"
          },
          {
            icons:"static/img/activity/exchange/icon-1/icon01.png",
            title:"定时发放更省心",
            cont:"后台支持控制即时或定时发放优惠券时间"
          },
          {
            icons:"static/img/activity/standby/icon-1/actstan02.png",
            title:"发券对象控制灵活",
            cont:"可控制手机号归属地、银行卡类别和银行新绑卡发券"
          },
          {
            icons:"static/img/activity/standby/icon-1/actstan03.png",
            title:"带动渠道任务完成量",
            cont:"带动更多用户完成渠道任务，增加渠道影响力"
          }
        ],
        activedatas:[
          {
            nums:"50个+", 
            explain:"活动数量"
          },
          {
            nums:"100万人次+", 
            explain:"参与人数"
          },
          {
            nums:"5500万元+", 
            explain:"优惠金额"
          },
          {
            nums:"20000万元+", 
            explain:"交易金额"
          }
        ],
        maskList:[
          {
            pics:"static/img/activity/actAdminSend/maspic/maspic01.png",
            title:"每月/周定时发券",
          },
          {
            pics:"static/img/activity/actAdminSend/maspic/maspic02.png",
            title:"白名单发券 （手机号/银行卡号）",
          }, 
          {
            pics:"static/img/activity/actAdminSend/maspic/maspic03.png",
            title:"指定银行卡类别/卡宾发券",
          }, {
            pics:"static/img/activity/actAdminSend/maspic/maspic04.png",
            title:"指定手机号归属地发券",
          },
          {
            pics:"static/img/activity/actAdminSend/maspic/maspic05.png",
            title:"指定渠道/商户核销使用",
          }, 
          {
            pics:"static/img/activity/actAdminSend/maspic/maspic06.png",
            title:"新用户自动发券",
          },
        ]
      }
    },
    mounted() {
      var wow = new WOW({
        boxClass: "wow",
        animateClass: "animated",
        offset: 0,
        mobile: true,
        live: false
      });
      wow.init();
    },
    methods: {
      changeanchorId(id) {
      $("html, body").animate({ scrollTop: $("#" + id).offset().top }, 1000);
      this.backTop = true;
      return false; // 返回false可以避免在原链接后加上#
    },
    }
  }
  </script>
  <style scoped lang="scss">
    @import "../../assets/css/activityClass/actAdminSend";
  </style>
  


// WEBPACK FOOTER //
// src/pages/activityTypePage/activity2-adminSend.vue